import { Component, ElementRef, Input, ViewChild, inject, Output } from '@angular/core';
import { iCatalogos, iEntrada } from '../entrada.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EntradaService } from '../entrada.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertaService } from '../../alerta/alerta.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectEntrada } from '../../states/entrada/selector';
import { ActivatedRoute } from '@angular/router';
import { cargaEntradaCampos } from '../../states/entrada/actions';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-add-edit-archivos',
  standalone: true,
  imports: [ReactiveFormsModule, MatToolbarModule, MatButtonModule, MatIconModule],
  templateUrl: './add-edit-archivos.component.html',
  styleUrl: './add-edit-archivos.component.css'
})
export class AddEditArchivosComponent {
  @ViewChild('inputFile') inputFile!: ElementRef;
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private alertaService = inject(AlertaService);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private formBuilder: FormBuilder = inject(FormBuilder);
  private subscriptions = new Subscription();
  
  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();
  
  public oEntrada: iEntrada;
  public formArchivos!: FormGroup;
  public archivos: any[] = [];
  public listFiles: File[] = [];
  public deshabilitado: boolean = false;
  public campos: any[] = [];

  constructor () {
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);

    this.formArchivos = this.formBuilder.group({
      inputFile: ['']
    });
  }

  ngOnInit () {    
    this.subscriptions.add(
      this.listenToFather.subscribe((oData: any) => {
        if(oData.accion == 'disabled') {
          this.deshabilitado = oData.deshabilitado;
        }
      })
    );

    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      this.cargaArchivos();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  async cargaArchivos () {
    this.loadingService.show();

    const busqueda = this.active.snapshot.queryParamMap.get('campo');
    this.campos = (busqueda?.split('|'))? busqueda?.split('|') : [];

    if(this.idEntrada && this.oEntrada.archivos.length > 0)
      this.archivos = await this.entradaService.getArchivos(this.idEntrada, this.oEntrada.archivos);
  
    this.store.dispatch(cargaEntradaCampos({ oData: {'archivos': [...this.archivos]} }));
    this.loadingService.hide();
  }

  confirmDelete (archivo: any) {
    if(!archivo.url) {
      this.deleteFile(archivo);
      return;
    }

    const dialogRef = this.alertaService.confirm({
      title: `¿Está seguro de eliminar el archivo?`,
      description: 'Confirme que desea eliminar el archivo, recuerde que esta acción es permanente.', 
      archivo: archivo
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if(!result) return;
      this.deleteFile(result.archivo);
    });
  }

  deleteFile (archivo: any) {
    this.archivos = this.archivos.filter((item: any) => { return item.name !==  archivo.name});
    this.listFiles = this.listFiles.filter((item: any) => { return item.name !==  archivo.name});
    this.store.dispatch(cargaEntradaCampos({ oData: {'archivos': [...this.archivos]} }));

    /*
      if(archivo.name && archivo.url)
        this.entradaService.delArchivo(this.idEntrada, archivo).then(() => {
          console.log(`archivo borrado: ${archivo.name}`);
        }).catch((error) => {
          this.alertaService.open('Error', `Ocurrio un problema al eliminar el archivo: ${archivo.name}`);
        });
    */
  }

  selectFile (event: any): void {
    const files = event.target.files;

    for(let i = 0; i < files.length; i++) {
      const file = files[i];
      this.agregarArchivo(file);
    }

    this.inputFile.nativeElement.value = '';
    this.store.dispatch(cargaEntradaCampos({ oData: {'archivos': [...this.archivos]} }));
  }

  agregarArchivo (file: any) {
    let archivoRepetido = false;

    for (let archivo of this.archivos) {
      if(archivo.name == file.name)
        archivoRepetido = true;
    }

    if(archivoRepetido) {
      this.alertaService.open("Error", "El archivo ya se encuentra seleccionado.");
      return;
    }

    this.archivos.push({name: file.name, metadata: file.type, file: file});
    this.listFiles.push(file);
  }

}